const state = {
  comments: new Map(),
};

const mutations = {
  ADD_COMMENT(state, { commentKey, comment }) {
    state.comments.set(commentKey, comment);
  },
  UPDATE_COMMENT(state, { commentId, comment }) {
    state.comments.set(commentId, comment);
  },
  DELETE_COMMENT(state, commentId) {
    state.comments.delete(commentId);
  },
  CLEAR_ALL_COMMENTS(state) {
    state.comments.clear();
  },
};

const getters = {
  allComments: (state) => state.comments,
  getSectionComments: (state) => (sectionId) => {
    const sectionComments = [];

    for (const [key, comment] of state.comments) {
      // Check if key contains the sectionId in the format: submissionId-sectionId-timestamp
      const matches = key.includes(`-${sectionId}-`);

      if (matches) {
        sectionComments.push({
          id: key,
          ...comment,
        });
      }
    }

    return sectionComments.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
  },
  hasSectionComments: (state) => (sectionId) => {
    for (const key of state.comments.keys()) {
      if (key.includes(`-${sectionId}-`)) {
        return true;
      }
    }

    return false;
  },
  getSectionCommentsCount: (state, getters) => (sectionId) => {
    return getters.getSectionComments(sectionId).length;
  },
  exportCommentsForPdf: (state) => {
    return Object.fromEntries(state.comments);
  },
};

const actions = {
  addComment({ commit, state }, { submissionId, sectionId, text, image }) {
    const hasExisting = Array.from(state.comments.keys()).some((key) => {
      const keyParts = key.split("-");

      if (keyParts.length >= 3) {
        const keySectionId = keyParts.slice(1, -1).join("-");

        return keySectionId === sectionId;
      }

      return false;
    });

    if (hasExisting) {
      throw new Error("Maximum of 1 comment allowed per section");
    }

    const timestamp = new Date().toISOString();
    const commentIndex = Date.now();
    const commentKey = `${submissionId}-${sectionId}-${commentIndex}`;

    const newComment = {
      text: text.trim(),
      sectionId,
      createdAt: timestamp,
      updatedAt: timestamp,
      type: "inline",
      image: image === undefined ? null : image,
    };

    commit("ADD_COMMENT", { commentKey, comment: newComment });

    return {
      id: commentKey,
      ...newComment,
    };
  },
  updateComment({ commit, state }, { commentId, newText, newImage }) {
    if (state.comments.has(commentId)) {
      const existingComment = state.comments.get(commentId);
      const updatedComment = {
        ...existingComment,
        text: newText.trim(),
        updatedAt: new Date().toISOString(),
      };

      if (newImage !== undefined) {
        updatedComment.image = newImage;
      }

      commit("UPDATE_COMMENT", { commentId, comment: updatedComment });

      return {
        id: commentId,
        ...updatedComment,
      };
    }

    return null;
  },
  deleteComment({ commit, state }, commentId) {
    if (state.comments.has(commentId)) {
      commit("DELETE_COMMENT", commentId);

      return true;
    }

    return false;
  },
  clearAllComments({ commit }) {
    commit("CLEAR_ALL_COMMENTS");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
